import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[imageScrollAnimation]',
  standalone: true,
})
export class ImageScrollAnimationDirective {
  constructor(private element: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    const scrollPos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const scaleToNumber = 0.7 + scrollPos / 1000;

    if (this.element) {
      if (scaleToNumber <= 1) {
        this.element?.nativeElement.style.setProperty(
          'transform',
          `scale(${scaleToNumber})`
        );
      }
    }
  }
}
